<div id="scale-container-{{mapIndex}}" [class.d-none]="discreteEnabled" [matMenuTriggerFor]="menu"></div>
<mat-menu #menu="matMenu" yPosition="above" class="scale-bar">
    @for (unit of units; track unit.value) {
        <button mat-menu-item [class.selected]="unitSelected===unit.value" (click)="onChangeUnit(unit.value)">
            {{ unit.viewValue }}
        </button>
    }
</mat-menu>